import { Button, ButtonGroup, Checkbox, Chip, Radio, ToggleButtonGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import { gqladm } from "../../../../graphql/gqladm";
import {
  ConsignmentSearchOption,
  ConsignmentStatus,
  ConsignmentStatusArray,
  StatusCount,
} from "../../../../types/elements";
import ColumnDiv from "../../../molecules/ColumnDiv";

interface ConsignmentSearchBoxProps {
  onSearch: (opt: ConsignmentSearchOption) => any;
}
const ConsignmentSearchBox: React.FC<ConsignmentSearchBoxProps> = (props) => {
  const [searchStatuses, setSearchStatuses] = useState<Array<ConsignmentStatus>>(
    ConsignmentStatusArray.filter((o) => o !== "작성 중" && o !== "취소")
  );
  const [searchOrder, setSearchOrder] = useState<"newerfirst" | "olderfirst" | "">("newerfirst");

  const [statusCounts, setStatusCounts] = useState<StatusCount[]>([]);

  const loadStatusCount = () => {
    gqladm.consignmentStatusCounts().then((result) => {
      setStatusCounts(result);
    });
  };
  useEffect(() => {
    loadStatusCount();
    handleSearch();
  }, []);

  const handleToggleSearchStatus = (status: ConsignmentStatus) => {
    setSearchStatuses((sss) =>
      sss.includes(status) ? sss.filter((o) => o !== status) : [...sss, status]
    );
  };

  const handleSearch = () => {
    const opt: ConsignmentSearchOption = {};
    if (searchStatuses.length > 0) opt.statuses = searchStatuses;
    if (searchOrder) opt.ordering = searchOrder;
    props.onSearch(opt);
  };
  return (
    <div className="consignmentSearchBox">
      <div style={{ marginBottom: "8px", fontWeight: "bold" }}>Consignment Search</div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        Status :&nbsp;
        {ConsignmentStatusArray.map((cs, csIdx) => {
          const count = statusCounts
            .filter((o) => o.status === cs)
            .map((o) => o.count)
            .reduce((p, n) => (p ?? 0) + (n ?? 0), 0);
          return (
            <Chip
              key={csIdx}
              className="statusChip"
              label={cs + `(${count})`}
              onClick={() => handleToggleSearchStatus(cs)}
              color={searchStatuses.includes(cs) ? "primary" : "default"}
              size="small"
            />
          );
        })}
      </div>

      <ColumnDiv label="정렬순서">
        <ButtonGroup size="small">
          <Button
            color={searchOrder === "" ? "info" : "inherit"}
            onClick={() => setSearchOrder("")}>
            No
          </Button>
          <Button
            color={searchOrder === "newerfirst" ? "info" : "inherit"}
            onClick={() => setSearchOrder("newerfirst")}>
            최근부터
          </Button>
          <Button
            color={searchOrder === "olderfirst" ? "info" : "inherit"}
            onClick={() => setSearchOrder("olderfirst")}>
            과거부터
          </Button>
        </ButtonGroup>
      </ColumnDiv>

      <div style={{ padding: "0.2rem", display: "flex" }}>
        {/* <Button>접기</Button> */}
        <Button variant="contained" fullWidth onClick={handleSearch}>
          검색
        </Button>
      </div>
    </div>
  );
};

export default ConsignmentSearchBox;
